import OperatorCreate from '@/views/operator/Create.vue'
import OperatorList from '@/views/operator/List.vue'
import OperatorManage from '@/views/operator/Manage.vue'

export default [
  {
    path: '/oc',
    name: 'operator-create',
    component: OperatorCreate,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'operator-list',
          title: 'Operators'
        },
        {
          link: 'operator-create',
          title: 'New Operator'
        }
      ],
      topbarGroup: 'users'
    }
  },
  {
    path: '/ol',
    name: 'operator-list',
    component: OperatorList,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'operator-list',
          title: 'Operators'
        }
      ],
      topbarGroup: 'users'
    }
  },
  {
    path: '/om/:id',
    name: 'operator-manage',
    component: OperatorManage,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'operator-list',
          title: 'Operators'
        },
        {
          link: 'operator-manage',
          title: 'Operator Manage',
          params: 'id'
        }
      ],
      topbarGroup: 'users'
    }
  }
]
